import React from 'react';
import styles from 'Custom/Card/HorizontalCard.module.scss';
import RichText from 'Custom/RichText';
import Button from 'Nori/Button';
import PHONE_DESKTOP from 'Images/misc/phone-circle-desktop.webp';
import PHONE_MOBILE from 'Images/misc/phone-circle-mobile.webp';
import Checkmark from 'Images/brand-icons/checkmark-tick.webp';
import Image from 'Nori/Image';
// import Checkmark from 'Images/brand-icons/checkmark.svg';
import SplitContent from 'Custom/Split/SplitContent';
import AjustableImage from 'Custom/AjustableImage';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';

const IMAGE_BACKGROUNDS = {
  primaryLight: styles.primaryLight,
  secondary2Light: styles.secondary2Light,
  secondary3Light: styles.secondary3Light,
  secondary4Light: styles.secondary4Light,
  default: styles.primaryLight,
};

const HorizontalCard = ({
  image,
  className = '',
  background = '',
  ...props
}) => {
  const PARAGRAPHS = [
    'Get timely reminders',
    'Remember your insertion date',
    'Prepare for removal',
  ];

  return (
    <SplitContent
      className={`${styles.phoneImage} ${className}`}
      reverse
      {...props}
    >
      <ItemBreakpoint breakpoint="md">
        <AjustableImage
          size="full"
          image={{ src: PHONE_DESKTOP, style: { width: 292 }, alt: '' }}
        />
        <AjustableImage size="full" image={{ src: PHONE_MOBILE, alt: '' }} />
      </ItemBreakpoint>
      <>
        <RichText
          className={styles.horizontalRichText}
          data-qa-tag="richtext already on nexplanon"
        >
          <h2 data-qa-tag="title Already on NEXPLANON?">
            Already on NEXPLANON?
          </h2>
          <p className="body-text">
            Receive tips to help you with your journey.
          </p>
          {PARAGRAPHS.map((text, index) => (
            <p className={`${styles.listItem} body-text`} key={`item-${index}`}>
              <Image src={Checkmark} width="24" height="24" alt="checkmark" />
              {/* <Checkmark className={styles.checkMark} /> */}
              <span>{text}</span>
            </p>
          ))}

          <Button
            className={styles.cta}
            href="/enrollment/"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label="Register My NEXPLANON"
            data-design-module_no={props['data-design-module_no']}
            data-qa-tag="button Register My NEXPLANON"
          >
            Register My NEXPLANON
          </Button>
        </RichText>
      </>
    </SplitContent>
  );
};

export default HorizontalCard;
